module.exports = __webpack_public_path__ + "img/bookbg.5566b20e.png";